(() => {
 if (window.sunrayHomeInitialized) return;
 window.sunrayHomeInitialized = true;
 const select = (root,index) => {
  [...root.querySelectorAll('[data-sr-slide]')].forEach((slide,i) => {slide.hidden=i!==index;});
  root.querySelectorAll('[data-sr-slide-button]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.srSlideButton)===index)));
 };
 document.addEventListener('click',event=>{
  const b=event.target.closest('[data-sr-slide-button]');
  if(b)select(b.closest('[data-sr-home-carousel]'),Number(b.dataset.srSlideButton));
 });
 document.addEventListener('shopify:block:select',event=>{
  const slide=event.target.closest('[data-sr-slide]');
  if(!slide)return;
  const root=slide.closest('[data-sr-home-carousel]');
  select(root,[...root.querySelectorAll('[data-sr-slide]')].indexOf(slide));
 });
})();
(() => {
 if(window.sunrayOpticsInitialized)return;window.sunrayOpticsInitialized=true;
 document.addEventListener('click',event=>{
 const zone=event.target.closest('[data-sr-zone-button]');
 if(zone){const root=zone.closest('[data-sr-zone-demo]'),n=Number(zone.dataset.srZoneButton);root.querySelectorAll('[data-sr-zone-button]').forEach(b=>b.setAttribute('aria-pressed',String(b===zone)));root.querySelectorAll('[data-sr-zone]').forEach(e=>e.setAttribute('fill-opacity',Number(e.dataset.srZone)===n?'1':'.3'));root.querySelector('[data-sr-zone-caption]').textContent=['Upper zone · Look around your surroundings.','Middle zone · Laptop and arm’s-length tasks.','Lower zone · Books, menus, and your phone.'][n];}
 const tint=event.target.closest('[data-sr-tint-button]');
 if(tint){const root=tint.closest('[data-sr-tint-demo]'),outside=tint.dataset.srTintButton==='outdoors';root.querySelectorAll('[data-sr-tint-button]').forEach(b=>b.setAttribute('aria-pressed',String(b===tint)));root.querySelectorAll('[data-sr-tint-lens]').forEach(e=>{e.setAttribute('fill',outside?'#344e41':'#fff');e.setAttribute('fill-opacity',outside?'.8':'.5');});root.querySelector('[data-sr-tint-caption]').textContent=outside?'Outdoors · UV exposure activates a darker tint.':'Indoors · Lenses gradually lighten.';}
 });
})();